import { useMemo } from 'react';

import { BrandLogo } from '../BrandLogo';
import { CustomComponent } from '../custom';

import { NavbarViewProps } from './type';

import { useTenantBranding } from '~hooks/tenant/useTenantBranding';

export const NavbarViewV1: React.FC<NavbarViewProps> = ({
  leftComponent,
  rightComponent,
}) => {
  const { logoUrl, displayName } = useTenantBranding();
  const defaultLeftComponent = useMemo(
    () => ({
      onlyChildren: true,
      children: (
        <BrandLogo
          src={logoUrl}
          name={displayName}
          maxWidth={130}
          maxHeight={40}
        />
      ),
    }),
    [logoUrl, displayName],
  );

  return (
    <>
      {/* DEFAULT IS CF LOGO */}
      {leftComponent !== 'empty' && (
        <CustomComponent {...(leftComponent ?? defaultLeftComponent)} />
      )}

      {rightComponent !== 'empty' && <CustomComponent {...rightComponent} />}
    </>
  );
};
